import { Component, OnInit } from '@angular/core';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-worksheet-page',
  templateUrl: './worksheet-page.component.html',
  styleUrls: ['./worksheet-page.component.scss'],
})
export class WorksheetPageComponent implements OnInit {
  populations = Populations;

  constructor() {}

  ngOnInit() {}
}
